"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { CSRF_HEADER, csrfToken } from "./csrf_token";
const CSRF_HEADER_LOWERCASE = CSRF_HEADER.toLowerCase();
const ABSOLUTE_URL = /^(?:[a-z]+:)?\/\//i;
const LOG_MISSING_TOKEN = process.env.NODE_ENV !== "production";
const port = location.port ? `:${location.port}` : "";
const origin = `${location.protocol}//${location.hostname}${port}`;
const tokenAlreadySet = /* @__PURE__ */ new WeakSet();
function sameOriginUrl(target) {
  if (!ABSOLUTE_URL.test(target)) {
    return true;
  }
  try {
    return new URL(target, origin).origin === origin;
  } catch (e) {
    return false;
  }
}
function warnMissingToken(method, target) {
  console.warn(
    `csrf_xhr sent ${method} ${target} without a ${CSRF_HEADER} header because the page has no <meta name="csrf-token"> content. Add csrf_meta_tags to the layout.`
  );
}
function installXhr() {
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;
  XMLHttpRequest.prototype.open = function(method, url, async = true, username, password) {
    const target = url.toString();
    const sameOrigin = sameOriginUrl(target);
    tokenAlreadySet.delete(this);
    originalOpen.call(this, method, url, async, username, password);
    const token = sameOrigin ? csrfToken() : null;
    if (token !== null) {
      this.setRequestHeader(CSRF_HEADER, token);
    } else if (sameOrigin && LOG_MISSING_TOKEN) {
      warnMissingToken(method, target);
    }
  };
  XMLHttpRequest.prototype.setRequestHeader = function(name, value) {
    if (name.toLowerCase() === CSRF_HEADER_LOWERCASE) {
      if (tokenAlreadySet.has(this)) {
        return;
      }
      tokenAlreadySet.add(this);
    }
    originalSetRequestHeader.call(this, name, value);
  };
}
function installFetch() {
  const originalFetch = globalThis.fetch;
  globalThis.fetch = function(input, init) {
    var _a, _b, _c;
    const request = typeof input !== "string" && !(input instanceof URL) ? input : null;
    const target = request ? request.url : input.toString();
    if (!sameOriginUrl(target)) {
      return originalFetch(input, init);
    }
    const token = csrfToken();
    if (token === null) {
      if (LOG_MISSING_TOKEN) {
        warnMissingToken((_b = (_a = init == null ? void 0 : init.method) != null ? _a : request == null ? void 0 : request.method) != null ? _b : "GET", target);
      }
      return originalFetch(input, init);
    }
    const headers = new Headers((_c = init == null ? void 0 : init.headers) != null ? _c : request == null ? void 0 : request.headers);
    if (headers.has(CSRF_HEADER)) {
      return originalFetch(input, init);
    }
    headers.set(CSRF_HEADER, token);
    return originalFetch(input, __spreadProps(__spreadValues({}, init), { headers }));
  };
}
const csrfWindow = window;
if (!csrfWindow.__csrfXhrInstalled) {
  installXhr();
  if (typeof globalThis.fetch === "function") {
    installFetch();
  }
  csrfWindow.__csrfXhrInstalled = true;
}
